export const DECK_STANDARD = 'standard';
export const DECK_FIBONACCI = 'fibonacci';
export const DECK_TSHIRT = 'tshirt';
export const DECK_RISK_PLANNING = 'risk_planning';

export const DECK_CARD_OPTION_COFFEE = 'coffee';
export const DECK_CARD_OPTION_QUESTION = '?';
export const DECK_CARD_OPTION_INFINITY = '∞';

export const DECK_MAP = new Map([
  [DECK_STANDARD, ['0', '.5', '1', '2', '3', '5', '8', '13', '20', '40', '100', DECK_CARD_OPTION_INFINITY, DECK_CARD_OPTION_QUESTION, DECK_CARD_OPTION_COFFEE]],
  [DECK_FIBONACCI, ['0', '1', '2', '3', '5', '8', '13', '21', '34', '55', '89', '144', DECK_CARD_OPTION_INFINITY, DECK_CARD_OPTION_QUESTION, DECK_CARD_OPTION_COFFEE]],
  [DECK_TSHIRT, ['XS', 'S', 'M', 'L', 'XL', 'XXL', DECK_CARD_OPTION_INFINITY, DECK_CARD_OPTION_QUESTION, DECK_CARD_OPTION_COFFEE]],
  [DECK_RISK_PLANNING, ['Green', 'Yellow', 'Amber', 'Purple', 'Red', DECK_CARD_OPTION_INFINITY, DECK_CARD_OPTION_QUESTION, DECK_CARD_OPTION_COFFEE]],
]);
